/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PrintRouteImport } from './routes/_print'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAdminRouteImport } from './routes/_app.admin'
import { Route as AppBanksRouteImport } from './routes/_app.banks'
import { Route as AppCollectionsRouteImport } from './routes/_app.collections'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppDocumentsRouteImport } from './routes/_app.documents'
import { Route as AppEmployersRouteImport } from './routes/_app.employers'
import { Route as AppMisRouteImport } from './routes/_app.mis'
import { Route as AppMyWorkRouteImport } from './routes/_app.my-work'
import { Route as AppOperationsRouteImport } from './routes/_app.operations'
import { Route as AppPerformanceRouteImport } from './routes/_app.performance'
import { Route as AppSetupRouteImport } from './routes/_app.setup'
import { Route as AppStaffCommissionRouteImport } from './routes/_app.staff-commission'
import { Route as LoginMfaRouteImport } from './routes/login_.mfa'
import { Route as LoginMfaSetupRouteImport } from './routes/login_.mfa-setup'
import { Route as AppAccountSessionsRouteImport } from './routes/_app.account.sessions'
import { Route as AppAdminIndexRouteImport } from './routes/_app.admin.index'
import { Route as AppAdminAuditLogRouteImport } from './routes/_app.admin.audit-log'
import { Route as AppAdminExternalPartiesRouteImport } from './routes/_app.admin.external-parties'
import { Route as AppAdminOrganizationRouteImport } from './routes/_app.admin.organization'
import { Route as AppAdminTeamsRouteImport } from './routes/_app.admin.teams'
import { Route as AppAdminUsersRouteImport } from './routes/_app.admin.users'
import { Route as AppBanksIndexRouteImport } from './routes/_app.banks.index'
import { Route as AppBanksNewRouteImport } from './routes/_app.banks.new'
import { Route as AppCollectionsIndexRouteImport } from './routes/_app.collections.index'
import { Route as AppCollectionsAdjustmentsRouteImport } from './routes/_app.collections.adjustments'
import { Route as AppCollectionsClawbacksRouteImport } from './routes/_app.collections.clawbacks'
import { Route as AppCollectionsReceivablesRouteImport } from './routes/_app.collections.receivables'
import { Route as AppCustomersIndexRouteImport } from './routes/_app.customers.index'
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app.customers.$customerId'
import { Route as AppDealsIndexRouteImport } from './routes/_app.deals.index'
import { Route as AppDealsDealIdRouteImport } from './routes/_app.deals.$dealId'
import { Route as AppDealsNewRouteImport } from './routes/_app.deals.new'
import { Route as AppDocumentsIndexRouteImport } from './routes/_app.documents.index'
import { Route as AppEmployersIndexRouteImport } from './routes/_app.employers.index'
import { Route as AppEmployersEmployerIdRouteImport } from './routes/_app.employers.$employerId'
import { Route as AppEmployersDuplicatesRouteImport } from './routes/_app.employers.duplicates'
import { Route as AppEmployersEnlistmentsRouteImport } from './routes/_app.employers.enlistments'
import { Route as AppEmployersNotInMasterRouteImport } from './routes/_app.employers.not-in-master'
import { Route as AppMisIndexRouteImport } from './routes/_app.mis.index'
import { Route as AppMisMovementRouteImport } from './routes/_app.mis.movement'
import { Route as AppPerformanceIndexRouteImport } from './routes/_app.performance.index'
import { Route as AppPerformanceTargetsRouteImport } from './routes/_app.performance.targets'
import { Route as AppReportsIndexRouteImport } from './routes/_app.reports.index'
import { Route as AppReportsReportKeyRouteImport } from './routes/_app.reports.$reportKey'
import { Route as AppStaffCommissionIndexRouteImport } from './routes/_app.staff-commission.index'
import { Route as AppStaffCommissionAdjustmentsRouteImport } from './routes/_app.staff-commission.adjustments'
import { Route as AppStaffCommissionClawbacksRouteImport } from './routes/_app.staff-commission.clawbacks'
import { Route as AppStaffCommissionRulesRouteImport } from './routes/_app.staff-commission.rules'
import { Route as AppAdminImportsIndexRouteImport } from './routes/_app.admin.imports.index'
import { Route as AppAdminRolesIndexRouteImport } from './routes/_app.admin.roles.index'
import { Route as AppAdminRolesCompareRouteImport } from './routes/_app.admin.roles.compare'
import { Route as AppAdminImportsImportIdRouteImport } from './routes/_app.admin_.imports.$importId'
import { Route as AppAdminRolesRoleIdRouteImport } from './routes/_app.admin_.roles.$roleId'
import { Route as AppAdminRolesNewRouteImport } from './routes/_app.admin_.roles.new'
import { Route as AppBanksBankIdIndexRouteImport } from './routes/_app.banks.$bankId.index'
import { Route as AppBanksBankIdEmployerCategoriesRouteImport } from './routes/_app.banks.$bankId.employer-categories'
import { Route as AppBanksBankIdStagesRouteImport } from './routes/_app.banks.$bankId.stages'
import { Route as AppCollectionsInvoicesIndexRouteImport } from './routes/_app.collections.invoices.index'
import { Route as AppCollectionsInvoicesInvoiceIdRouteImport } from './routes/_app.collections.invoices.$invoiceId'
import { Route as AppCollectionsInvoicesNewRouteImport } from './routes/_app.collections.invoices.new'
import { Route as AppCollectionsPaymentsIndexRouteImport } from './routes/_app.collections.payments.index'
import { Route as AppCollectionsPaymentsPaymentIdRouteImport } from './routes/_app.collections.payments.$paymentId'
import { Route as AppCollectionsReconciliationIndexRouteImport } from './routes/_app.collections.reconciliation.index'
import { Route as AppCollectionsReconciliationRunIdRouteImport } from './routes/_app.collections.reconciliation.$runId'
import { Route as AppDealsDealIdIndexRouteImport } from './routes/_app.deals.$dealId.index'
import { Route as AppDealsDealIdActivityRouteImport } from './routes/_app.deals.$dealId.activity'
import { Route as AppDealsDealIdApplicationRouteImport } from './routes/_app.deals.$dealId.application'
import { Route as AppDealsDealIdBankUpdatesRouteImport } from './routes/_app.deals.$dealId.bank-updates'
import { Route as AppDealsDealIdCalculatorRouteImport } from './routes/_app.deals.$dealId.calculator'
import { Route as AppDealsDealIdDocumentsRouteImport } from './routes/_app.deals.$dealId.documents'
import { Route as AppDealsDealIdFinancialRouteImport } from './routes/_app.deals.$dealId.financial'
import { Route as AppDealsDealIdOperationsRouteImport } from './routes/_app.deals.$dealId.operations'
import { Route as AppDealsDealIdPeopleRouteImport } from './routes/_app.deals.$dealId.people'
import { Route as AppDealsDealIdSettlementRouteImport } from './routes/_app.deals.$dealId.settlement'
import { Route as AppDealsDealIdEditRouteImport } from './routes/_app.deals.$dealId_.edit'
import { Route as AppStaffCommissionPayoutRunsIndexRouteImport } from './routes/_app.staff-commission.payout-runs.index'
import { Route as AppStaffCommissionPayoutRunsRunIdRouteImport } from './routes/_app.staff-commission.payout-runs.$runId'
import { Route as AppStaffCommissionStatementsIndexRouteImport } from './routes/_app.staff-commission.statements.index'
import { Route as AppBanksBankIdProductsNewRouteImport } from './routes/_app.banks.$bankId.products.new'
import { Route as AppStaffCommissionStatementsUserIdPeriodRouteImport } from './routes/_app.staff-commission.statements.$userId.$period'
import { Route as PrintDealsDealIdApplicationPrintRouteImport } from './routes/_print.deals.$dealId.application.print'
import { Route as AppBanksBankIdProductsProductIdIndexRouteImport } from './routes/_app.banks.$bankId.products.$productId.index'
import { Route as AppBanksBankIdProductsProductIdVersionsVersionNoRouteImport } from './routes/_app.banks.$bankId.products.$productId.versions.$versionNo'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PrintRoute = PrintRouteImport.update({
  id: '/_print',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppBanksRoute = AppBanksRouteImport.update({
  id: '/banks',
  path: '/banks',
  getParentRoute: () => AppRoute,
} as any)
const AppCollectionsRoute = AppCollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsRoute = AppDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppRoute,
} as any)
const AppEmployersRoute = AppEmployersRouteImport.update({
  id: '/employers',
  path: '/employers',
  getParentRoute: () => AppRoute,
} as any)
const AppMisRoute = AppMisRouteImport.update({
  id: '/mis',
  path: '/mis',
  getParentRoute: () => AppRoute,
} as any)
const AppMyWorkRoute = AppMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => AppRoute,
} as any)
const AppOperationsRoute = AppOperationsRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => AppRoute,
} as any)
const AppPerformanceRoute = AppPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AppRoute,
} as any)
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffCommissionRoute = AppStaffCommissionRouteImport.update({
  id: '/staff-commission',
  path: '/staff-commission',
  getParentRoute: () => AppRoute,
} as any)
const LoginMfaRoute = LoginMfaRouteImport.update({
  id: '/login_/mfa',
  path: '/login/mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginMfaSetupRoute = LoginMfaSetupRouteImport.update({
  id: '/login_/mfa-setup',
  path: '/login/mfa-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountSessionsRoute = AppAccountSessionsRouteImport.update({
  id: '/account/sessions',
  path: '/account/sessions',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditLogRoute = AppAdminAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminExternalPartiesRoute = AppAdminExternalPartiesRouteImport.update({
  id: '/external-parties',
  path: '/external-parties',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminOrganizationRoute = AppAdminOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTeamsRoute = AppAdminTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppBanksIndexRoute = AppBanksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBanksRoute,
} as any)
const AppBanksNewRoute = AppBanksNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppBanksRoute,
} as any)
const AppCollectionsIndexRoute = AppCollectionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCollectionsRoute,
} as any)
const AppCollectionsAdjustmentsRoute =
  AppCollectionsAdjustmentsRouteImport.update({
    id: '/adjustments',
    path: '/adjustments',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppCollectionsClawbacksRoute = AppCollectionsClawbacksRouteImport.update({
  id: '/clawbacks',
  path: '/clawbacks',
  getParentRoute: () => AppCollectionsRoute,
} as any)
const AppCollectionsReceivablesRoute =
  AppCollectionsReceivablesRouteImport.update({
    id: '/receivables',
    path: '/receivables',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsIndexRoute = AppDealsIndexRouteImport.update({
  id: '/deals/',
  path: '/deals/',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsDealIdRoute = AppDealsDealIdRouteImport.update({
  id: '/deals/$dealId',
  path: '/deals/$dealId',
  getParentRoute: () => AppRoute,
} as any)
const AppDealsNewRoute = AppDealsNewRouteImport.update({
  id: '/deals/new',
  path: '/deals/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDocumentsRoute,
} as any)
const AppEmployersIndexRoute = AppEmployersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppEmployersRoute,
} as any)
const AppEmployersEmployerIdRoute = AppEmployersEmployerIdRouteImport.update({
  id: '/$employerId',
  path: '/$employerId',
  getParentRoute: () => AppEmployersRoute,
} as any)
const AppEmployersDuplicatesRoute = AppEmployersDuplicatesRouteImport.update({
  id: '/duplicates',
  path: '/duplicates',
  getParentRoute: () => AppEmployersRoute,
} as any)
const AppEmployersEnlistmentsRoute = AppEmployersEnlistmentsRouteImport.update({
  id: '/enlistments',
  path: '/enlistments',
  getParentRoute: () => AppEmployersRoute,
} as any)
const AppEmployersNotInMasterRoute = AppEmployersNotInMasterRouteImport.update({
  id: '/not-in-master',
  path: '/not-in-master',
  getParentRoute: () => AppEmployersRoute,
} as any)
const AppMisIndexRoute = AppMisIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMisRoute,
} as any)
const AppMisMovementRoute = AppMisMovementRouteImport.update({
  id: '/movement',
  path: '/movement',
  getParentRoute: () => AppMisRoute,
} as any)
const AppPerformanceIndexRoute = AppPerformanceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPerformanceRoute,
} as any)
const AppPerformanceTargetsRoute = AppPerformanceTargetsRouteImport.update({
  id: '/targets',
  path: '/targets',
  getParentRoute: () => AppPerformanceRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsReportKeyRoute = AppReportsReportKeyRouteImport.update({
  id: '/reports/$reportKey',
  path: '/reports/$reportKey',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffCommissionIndexRoute = AppStaffCommissionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppStaffCommissionRoute,
} as any)
const AppStaffCommissionAdjustmentsRoute =
  AppStaffCommissionAdjustmentsRouteImport.update({
    id: '/adjustments',
    path: '/adjustments',
    getParentRoute: () => AppStaffCommissionRoute,
  } as any)
const AppStaffCommissionClawbacksRoute =
  AppStaffCommissionClawbacksRouteImport.update({
    id: '/clawbacks',
    path: '/clawbacks',
    getParentRoute: () => AppStaffCommissionRoute,
  } as any)
const AppStaffCommissionRulesRoute = AppStaffCommissionRulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => AppStaffCommissionRoute,
} as any)
const AppAdminImportsIndexRoute = AppAdminImportsIndexRouteImport.update({
  id: '/imports/',
  path: '/imports/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesIndexRoute = AppAdminRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesCompareRoute = AppAdminRolesCompareRouteImport.update({
  id: '/roles/compare',
  path: '/roles/compare',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminImportsImportIdRoute = AppAdminImportsImportIdRouteImport.update({
  id: '/admin_/imports/$importId',
  path: '/admin/imports/$importId',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRolesRoleIdRoute = AppAdminRolesRoleIdRouteImport.update({
  id: '/admin_/roles/$roleId',
  path: '/admin/roles/$roleId',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRolesNewRoute = AppAdminRolesNewRouteImport.update({
  id: '/admin_/roles/new',
  path: '/admin/roles/new',
  getParentRoute: () => AppRoute,
} as any)
const AppBanksBankIdIndexRoute = AppBanksBankIdIndexRouteImport.update({
  id: '/$bankId/',
  path: '/$bankId/',
  getParentRoute: () => AppBanksRoute,
} as any)
const AppBanksBankIdEmployerCategoriesRoute =
  AppBanksBankIdEmployerCategoriesRouteImport.update({
    id: '/$bankId/employer-categories',
    path: '/$bankId/employer-categories',
    getParentRoute: () => AppBanksRoute,
  } as any)
const AppBanksBankIdStagesRoute = AppBanksBankIdStagesRouteImport.update({
  id: '/$bankId/stages',
  path: '/$bankId/stages',
  getParentRoute: () => AppBanksRoute,
} as any)
const AppCollectionsInvoicesIndexRoute =
  AppCollectionsInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppCollectionsInvoicesInvoiceIdRoute =
  AppCollectionsInvoicesInvoiceIdRouteImport.update({
    id: '/invoices/$invoiceId',
    path: '/invoices/$invoiceId',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppCollectionsInvoicesNewRoute =
  AppCollectionsInvoicesNewRouteImport.update({
    id: '/invoices/new',
    path: '/invoices/new',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppCollectionsPaymentsIndexRoute =
  AppCollectionsPaymentsIndexRouteImport.update({
    id: '/payments/',
    path: '/payments/',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppCollectionsPaymentsPaymentIdRoute =
  AppCollectionsPaymentsPaymentIdRouteImport.update({
    id: '/payments/$paymentId',
    path: '/payments/$paymentId',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppCollectionsReconciliationIndexRoute =
  AppCollectionsReconciliationIndexRouteImport.update({
    id: '/reconciliation/',
    path: '/reconciliation/',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppCollectionsReconciliationRunIdRoute =
  AppCollectionsReconciliationRunIdRouteImport.update({
    id: '/reconciliation/$runId',
    path: '/reconciliation/$runId',
    getParentRoute: () => AppCollectionsRoute,
  } as any)
const AppDealsDealIdIndexRoute = AppDealsDealIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDealsDealIdRoute,
} as any)
const AppDealsDealIdActivityRoute = AppDealsDealIdActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppDealsDealIdRoute,
} as any)
const AppDealsDealIdApplicationRoute =
  AppDealsDealIdApplicationRouteImport.update({
    id: '/application',
    path: '/application',
    getParentRoute: () => AppDealsDealIdRoute,
  } as any)
const AppDealsDealIdBankUpdatesRoute =
  AppDealsDealIdBankUpdatesRouteImport.update({
    id: '/bank-updates',
    path: '/bank-updates',
    getParentRoute: () => AppDealsDealIdRoute,
  } as any)
const AppDealsDealIdCalculatorRoute =
  AppDealsDealIdCalculatorRouteImport.update({
    id: '/calculator',
    path: '/calculator',
    getParentRoute: () => AppDealsDealIdRoute,
  } as any)
const AppDealsDealIdDocumentsRoute = AppDealsDealIdDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AppDealsDealIdRoute,
} as any)
const AppDealsDealIdFinancialRoute = AppDealsDealIdFinancialRouteImport.update({
  id: '/financial',
  path: '/financial',
  getParentRoute: () => AppDealsDealIdRoute,
} as any)
const AppDealsDealIdOperationsRoute =
  AppDealsDealIdOperationsRouteImport.update({
    id: '/operations',
    path: '/operations',
    getParentRoute: () => AppDealsDealIdRoute,
  } as any)
const AppDealsDealIdPeopleRoute = AppDealsDealIdPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AppDealsDealIdRoute,
} as any)
const AppDealsDealIdSettlementRoute =
  AppDealsDealIdSettlementRouteImport.update({
    id: '/settlement',
    path: '/settlement',
    getParentRoute: () => AppDealsDealIdRoute,
  } as any)
const AppDealsDealIdEditRoute = AppDealsDealIdEditRouteImport.update({
  id: '/deals/$dealId_/edit',
  path: '/deals/$dealId/edit',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffCommissionPayoutRunsIndexRoute =
  AppStaffCommissionPayoutRunsIndexRouteImport.update({
    id: '/payout-runs/',
    path: '/payout-runs/',
    getParentRoute: () => AppStaffCommissionRoute,
  } as any)
const AppStaffCommissionPayoutRunsRunIdRoute =
  AppStaffCommissionPayoutRunsRunIdRouteImport.update({
    id: '/payout-runs/$runId',
    path: '/payout-runs/$runId',
    getParentRoute: () => AppStaffCommissionRoute,
  } as any)
const AppStaffCommissionStatementsIndexRoute =
  AppStaffCommissionStatementsIndexRouteImport.update({
    id: '/statements/',
    path: '/statements/',
    getParentRoute: () => AppStaffCommissionRoute,
  } as any)
const AppBanksBankIdProductsNewRoute =
  AppBanksBankIdProductsNewRouteImport.update({
    id: '/$bankId/products/new',
    path: '/$bankId/products/new',
    getParentRoute: () => AppBanksRoute,
  } as any)
const AppStaffCommissionStatementsUserIdPeriodRoute =
  AppStaffCommissionStatementsUserIdPeriodRouteImport.update({
    id: '/statements/$userId/$period',
    path: '/statements/$userId/$period',
    getParentRoute: () => AppStaffCommissionRoute,
  } as any)
const PrintDealsDealIdApplicationPrintRoute =
  PrintDealsDealIdApplicationPrintRouteImport.update({
    id: '/deals/$dealId/application/print',
    path: '/deals/$dealId/application/print',
    getParentRoute: () => PrintRoute,
  } as any)
const AppBanksBankIdProductsProductIdIndexRoute =
  AppBanksBankIdProductsProductIdIndexRouteImport.update({
    id: '/$bankId/products/$productId/',
    path: '/$bankId/products/$productId/',
    getParentRoute: () => AppBanksRoute,
  } as any)
const AppBanksBankIdProductsProductIdVersionsVersionNoRoute =
  AppBanksBankIdProductsProductIdVersionsVersionNoRouteImport.update({
    id: '/$bankId/products/$productId/versions/$versionNo',
    path: '/$bankId/products/$productId/versions/$versionNo',
    getParentRoute: () => AppBanksRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$': typeof SplatRoute
  '/': typeof AppIndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/banks': typeof AppBanksRouteWithChildren
  '/collections': typeof AppCollectionsRouteWithChildren
  '/dashboard': typeof AppDashboardRoute
  '/documents': typeof AppDocumentsRouteWithChildren
  '/employers': typeof AppEmployersRouteWithChildren
  '/mis': typeof AppMisRouteWithChildren
  '/my-work': typeof AppMyWorkRoute
  '/operations': typeof AppOperationsRoute
  '/performance': typeof AppPerformanceRouteWithChildren
  '/setup': typeof AppSetupRoute
  '/staff-commission': typeof AppStaffCommissionRouteWithChildren
  '/login/mfa': typeof LoginMfaRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/account/sessions': typeof AppAccountSessionsRoute
  '/admin/audit-log': typeof AppAdminAuditLogRoute
  '/admin/external-parties': typeof AppAdminExternalPartiesRoute
  '/admin/organization': typeof AppAdminOrganizationRoute
  '/admin/teams': typeof AppAdminTeamsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/banks/new': typeof AppBanksNewRoute
  '/collections/adjustments': typeof AppCollectionsAdjustmentsRoute
  '/collections/clawbacks': typeof AppCollectionsClawbacksRoute
  '/collections/receivables': typeof AppCollectionsReceivablesRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/deals/$dealId': typeof AppDealsDealIdRouteWithChildren
  '/deals/new': typeof AppDealsNewRoute
  '/employers/$employerId': typeof AppEmployersEmployerIdRoute
  '/employers/duplicates': typeof AppEmployersDuplicatesRoute
  '/employers/enlistments': typeof AppEmployersEnlistmentsRoute
  '/employers/not-in-master': typeof AppEmployersNotInMasterRoute
  '/mis/movement': typeof AppMisMovementRoute
  '/performance/targets': typeof AppPerformanceTargetsRoute
  '/reports/$reportKey': typeof AppReportsReportKeyRoute
  '/staff-commission/adjustments': typeof AppStaffCommissionAdjustmentsRoute
  '/staff-commission/clawbacks': typeof AppStaffCommissionClawbacksRoute
  '/staff-commission/rules': typeof AppStaffCommissionRulesRoute
  '/admin/': typeof AppAdminIndexRoute
  '/banks/': typeof AppBanksIndexRoute
  '/collections/': typeof AppCollectionsIndexRoute
  '/customers/': typeof AppCustomersIndexRoute
  '/deals/': typeof AppDealsIndexRoute
  '/documents/': typeof AppDocumentsIndexRoute
  '/employers/': typeof AppEmployersIndexRoute
  '/mis/': typeof AppMisIndexRoute
  '/performance/': typeof AppPerformanceIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/staff-commission/': typeof AppStaffCommissionIndexRoute
  '/admin/roles/compare': typeof AppAdminRolesCompareRoute
  '/admin/imports/$importId': typeof AppAdminImportsImportIdRoute
  '/admin/roles/$roleId': typeof AppAdminRolesRoleIdRoute
  '/admin/roles/new': typeof AppAdminRolesNewRoute
  '/banks/$bankId/employer-categories': typeof AppBanksBankIdEmployerCategoriesRoute
  '/banks/$bankId/stages': typeof AppBanksBankIdStagesRoute
  '/collections/invoices/$invoiceId': typeof AppCollectionsInvoicesInvoiceIdRoute
  '/collections/invoices/new': typeof AppCollectionsInvoicesNewRoute
  '/collections/payments/$paymentId': typeof AppCollectionsPaymentsPaymentIdRoute
  '/collections/reconciliation/$runId': typeof AppCollectionsReconciliationRunIdRoute
  '/deals/$dealId/activity': typeof AppDealsDealIdActivityRoute
  '/deals/$dealId/application': typeof AppDealsDealIdApplicationRoute
  '/deals/$dealId/bank-updates': typeof AppDealsDealIdBankUpdatesRoute
  '/deals/$dealId/calculator': typeof AppDealsDealIdCalculatorRoute
  '/deals/$dealId/documents': typeof AppDealsDealIdDocumentsRoute
  '/deals/$dealId/financial': typeof AppDealsDealIdFinancialRoute
  '/deals/$dealId/operations': typeof AppDealsDealIdOperationsRoute
  '/deals/$dealId/people': typeof AppDealsDealIdPeopleRoute
  '/deals/$dealId/settlement': typeof AppDealsDealIdSettlementRoute
  '/deals/$dealId/edit': typeof AppDealsDealIdEditRoute
  '/staff-commission/payout-runs/$runId': typeof AppStaffCommissionPayoutRunsRunIdRoute
  '/admin/imports/': typeof AppAdminImportsIndexRoute
  '/admin/roles/': typeof AppAdminRolesIndexRoute
  '/banks/$bankId/': typeof AppBanksBankIdIndexRoute
  '/collections/invoices/': typeof AppCollectionsInvoicesIndexRoute
  '/collections/payments/': typeof AppCollectionsPaymentsIndexRoute
  '/collections/reconciliation/': typeof AppCollectionsReconciliationIndexRoute
  '/deals/$dealId/': typeof AppDealsDealIdIndexRoute
  '/staff-commission/payout-runs/': typeof AppStaffCommissionPayoutRunsIndexRoute
  '/staff-commission/statements/': typeof AppStaffCommissionStatementsIndexRoute
  '/banks/$bankId/products/new': typeof AppBanksBankIdProductsNewRoute
  '/staff-commission/statements/$userId/$period': typeof AppStaffCommissionStatementsUserIdPeriodRoute
  '/deals/$dealId/application/print': typeof PrintDealsDealIdApplicationPrintRoute
  '/banks/$bankId/products/$productId/': typeof AppBanksBankIdProductsProductIdIndexRoute
  '/banks/$bankId/products/$productId/versions/$versionNo': typeof AppBanksBankIdProductsProductIdVersionsVersionNoRoute
}
export interface FileRoutesByTo {
  '/$': typeof SplatRoute
  '/': typeof AppIndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/dashboard': typeof AppDashboardRoute
  '/my-work': typeof AppMyWorkRoute
  '/operations': typeof AppOperationsRoute
  '/setup': typeof AppSetupRoute
  '/login/mfa': typeof LoginMfaRoute
  '/login/mfa-setup': typeof LoginMfaSetupRoute
  '/account/sessions': typeof AppAccountSessionsRoute
  '/admin/audit-log': typeof AppAdminAuditLogRoute
  '/admin/external-parties': typeof AppAdminExternalPartiesRoute
  '/admin/organization': typeof AppAdminOrganizationRoute
  '/admin/teams': typeof AppAdminTeamsRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/banks/new': typeof AppBanksNewRoute
  '/collections/adjustments': typeof AppCollectionsAdjustmentsRoute
  '/collections/clawbacks': typeof AppCollectionsClawbacksRoute
  '/collections/receivables': typeof AppCollectionsReceivablesRoute
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/deals/new': typeof AppDealsNewRoute
  '/employers/$employerId': typeof AppEmployersEmployerIdRoute
  '/employers/duplicates': typeof AppEmployersDuplicatesRoute
  '/employers/enlistments': typeof AppEmployersEnlistmentsRoute
  '/employers/not-in-master': typeof AppEmployersNotInMasterRoute
  '/mis/movement': typeof AppMisMovementRoute
  '/performance/targets': typeof AppPerformanceTargetsRoute
  '/reports/$reportKey': typeof AppReportsReportKeyRoute
  '/staff-commission/adjustments': typeof AppStaffCommissionAdjustmentsRoute
  '/staff-commission/clawbacks': typeof AppStaffCommissionClawbacksRoute
  '/staff-commission/rules': typeof AppStaffCommissionRulesRoute
  '/admin': typeof AppAdminIndexRoute
  '/banks': typeof AppBanksIndexRoute
  '/collections': typeof AppCollectionsIndexRoute
  '/customers': typeof AppCustomersIndexRoute
  '/deals': typeof AppDealsIndexRoute
  '/documents': typeof AppDocumentsIndexRoute
  '/employers': typeof AppEmployersIndexRoute
  '/mis': typeof AppMisIndexRoute
  '/performance': typeof AppPerformanceIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/staff-commission': typeof AppStaffCommissionIndexRoute
  '/admin/roles/compare': typeof AppAdminRolesCompareRoute
  '/admin/imports/$importId': typeof AppAdminImportsImportIdRoute
  '/admin/roles/$roleId': typeof AppAdminRolesRoleIdRoute
  '/admin/roles/new': typeof AppAdminRolesNewRoute
  '/banks/$bankId/employer-categories': typeof AppBanksBankIdEmployerCategoriesRoute
  '/banks/$bankId/stages': typeof AppBanksBankIdStagesRoute
  '/collections/invoices/$invoiceId': typeof AppCollectionsInvoicesInvoiceIdRoute
  '/collections/invoices/new': typeof AppCollectionsInvoicesNewRoute
  '/collections/payments/$paymentId': typeof AppCollectionsPaymentsPaymentIdRoute
  '/collections/reconciliation/$runId': typeof AppCollectionsReconciliationRunIdRoute
  '/deals/$dealId/activity': typeof AppDealsDealIdActivityRoute
  '/deals/$dealId/application': typeof AppDealsDealIdApplicationRoute
  '/deals/$dealId/bank-updates': typeof AppDealsDealIdBankUpdatesRoute
  '/deals/$dealId/calculator': typeof AppDealsDealIdCalculatorRoute
  '/deals/$dealId/documents': typeof AppDealsDealIdDocumentsRoute
  '/deals/$dealId/financial': typeof AppDealsDealIdFinancialRoute
  '/deals/$dealId/operations': typeof AppDealsDealIdOperationsRoute
  '/deals/$dealId/people': typeof AppDealsDealIdPeopleRoute
  '/deals/$dealId/settlement': typeof AppDealsDealIdSettlementRoute
  '/deals/$dealId/edit': typeof AppDealsDealIdEditRoute
  '/staff-commission/payout-runs/$runId': typeof AppStaffCommissionPayoutRunsRunIdRoute
  '/admin/imports': typeof AppAdminImportsIndexRoute
  '/admin/roles': typeof AppAdminRolesIndexRoute
  '/banks/$bankId': typeof AppBanksBankIdIndexRoute
  '/collections/invoices': typeof AppCollectionsInvoicesIndexRoute
  '/collections/payments': typeof AppCollectionsPaymentsIndexRoute
  '/collections/reconciliation': typeof AppCollectionsReconciliationIndexRoute
  '/deals/$dealId': typeof AppDealsDealIdIndexRoute
  '/staff-commission/payout-runs': typeof AppStaffCommissionPayoutRunsIndexRoute
  '/staff-commission/statements': typeof AppStaffCommissionStatementsIndexRoute
  '/banks/$bankId/products/new': typeof AppBanksBankIdProductsNewRoute
  '/staff-commission/statements/$userId/$period': typeof AppStaffCommissionStatementsUserIdPeriodRoute
  '/deals/$dealId/application/print': typeof PrintDealsDealIdApplicationPrintRoute
  '/banks/$bankId/products/$productId': typeof AppBanksBankIdProductsProductIdIndexRoute
  '/banks/$bankId/products/$productId/versions/$versionNo': typeof AppBanksBankIdProductsProductIdVersionsVersionNoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$': typeof SplatRoute
  '/_app': typeof AppRouteWithChildren
  '/_print': typeof PrintRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/banks': typeof AppBanksRouteWithChildren
  '/_app/collections': typeof AppCollectionsRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/documents': typeof AppDocumentsRouteWithChildren
  '/_app/employers': typeof AppEmployersRouteWithChildren
  '/_app/mis': typeof AppMisRouteWithChildren
  '/_app/my-work': typeof AppMyWorkRoute
  '/_app/operations': typeof AppOperationsRoute
  '/_app/performance': typeof AppPerformanceRouteWithChildren
  '/_app/setup': typeof AppSetupRoute
  '/_app/staff-commission': typeof AppStaffCommissionRouteWithChildren
  '/login_/mfa': typeof LoginMfaRoute
  '/login_/mfa-setup': typeof LoginMfaSetupRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account/sessions': typeof AppAccountSessionsRoute
  '/_app/admin/audit-log': typeof AppAdminAuditLogRoute
  '/_app/admin/external-parties': typeof AppAdminExternalPartiesRoute
  '/_app/admin/organization': typeof AppAdminOrganizationRoute
  '/_app/admin/teams': typeof AppAdminTeamsRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/banks/new': typeof AppBanksNewRoute
  '/_app/collections/adjustments': typeof AppCollectionsAdjustmentsRoute
  '/_app/collections/clawbacks': typeof AppCollectionsClawbacksRoute
  '/_app/collections/receivables': typeof AppCollectionsReceivablesRoute
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute
  '/_app/deals/$dealId': typeof AppDealsDealIdRouteWithChildren
  '/_app/deals/new': typeof AppDealsNewRoute
  '/_app/employers/$employerId': typeof AppEmployersEmployerIdRoute
  '/_app/employers/duplicates': typeof AppEmployersDuplicatesRoute
  '/_app/employers/enlistments': typeof AppEmployersEnlistmentsRoute
  '/_app/employers/not-in-master': typeof AppEmployersNotInMasterRoute
  '/_app/mis/movement': typeof AppMisMovementRoute
  '/_app/performance/targets': typeof AppPerformanceTargetsRoute
  '/_app/reports/$reportKey': typeof AppReportsReportKeyRoute
  '/_app/staff-commission/adjustments': typeof AppStaffCommissionAdjustmentsRoute
  '/_app/staff-commission/clawbacks': typeof AppStaffCommissionClawbacksRoute
  '/_app/staff-commission/rules': typeof AppStaffCommissionRulesRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/banks/': typeof AppBanksIndexRoute
  '/_app/collections/': typeof AppCollectionsIndexRoute
  '/_app/customers/': typeof AppCustomersIndexRoute
  '/_app/deals/': typeof AppDealsIndexRoute
  '/_app/documents/': typeof AppDocumentsIndexRoute
  '/_app/employers/': typeof AppEmployersIndexRoute
  '/_app/mis/': typeof AppMisIndexRoute
  '/_app/performance/': typeof AppPerformanceIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/staff-commission/': typeof AppStaffCommissionIndexRoute
  '/_app/admin/roles/compare': typeof AppAdminRolesCompareRoute
  '/_app/admin_/imports/$importId': typeof AppAdminImportsImportIdRoute
  '/_app/admin_/roles/$roleId': typeof AppAdminRolesRoleIdRoute
  '/_app/admin_/roles/new': typeof AppAdminRolesNewRoute
  '/_app/banks/$bankId/employer-categories': typeof AppBanksBankIdEmployerCategoriesRoute
  '/_app/banks/$bankId/stages': typeof AppBanksBankIdStagesRoute
  '/_app/collections/invoices/$invoiceId': typeof AppCollectionsInvoicesInvoiceIdRoute
  '/_app/collections/invoices/new': typeof AppCollectionsInvoicesNewRoute
  '/_app/collections/payments/$paymentId': typeof AppCollectionsPaymentsPaymentIdRoute
  '/_app/collections/reconciliation/$runId': typeof AppCollectionsReconciliationRunIdRoute
  '/_app/deals/$dealId/activity': typeof AppDealsDealIdActivityRoute
  '/_app/deals/$dealId/application': typeof AppDealsDealIdApplicationRoute
  '/_app/deals/$dealId/bank-updates': typeof AppDealsDealIdBankUpdatesRoute
  '/_app/deals/$dealId/calculator': typeof AppDealsDealIdCalculatorRoute
  '/_app/deals/$dealId/documents': typeof AppDealsDealIdDocumentsRoute
  '/_app/deals/$dealId/financial': typeof AppDealsDealIdFinancialRoute
  '/_app/deals/$dealId/operations': typeof AppDealsDealIdOperationsRoute
  '/_app/deals/$dealId/people': typeof AppDealsDealIdPeopleRoute
  '/_app/deals/$dealId/settlement': typeof AppDealsDealIdSettlementRoute
  '/_app/deals/$dealId_/edit': typeof AppDealsDealIdEditRoute
  '/_app/staff-commission/payout-runs/$runId': typeof AppStaffCommissionPayoutRunsRunIdRoute
  '/_app/admin/imports/': typeof AppAdminImportsIndexRoute
  '/_app/admin/roles/': typeof AppAdminRolesIndexRoute
  '/_app/banks/$bankId/': typeof AppBanksBankIdIndexRoute
  '/_app/collections/invoices/': typeof AppCollectionsInvoicesIndexRoute
  '/_app/collections/payments/': typeof AppCollectionsPaymentsIndexRoute
  '/_app/collections/reconciliation/': typeof AppCollectionsReconciliationIndexRoute
  '/_app/deals/$dealId/': typeof AppDealsDealIdIndexRoute
  '/_app/staff-commission/payout-runs/': typeof AppStaffCommissionPayoutRunsIndexRoute
  '/_app/staff-commission/statements/': typeof AppStaffCommissionStatementsIndexRoute
  '/_app/banks/$bankId/products/new': typeof AppBanksBankIdProductsNewRoute
  '/_app/staff-commission/statements/$userId/$period': typeof AppStaffCommissionStatementsUserIdPeriodRoute
  '/_print/deals/$dealId/application/print': typeof PrintDealsDealIdApplicationPrintRoute
  '/_app/banks/$bankId/products/$productId/': typeof AppBanksBankIdProductsProductIdIndexRoute
  '/_app/banks/$bankId/products/$productId/versions/$versionNo': typeof AppBanksBankIdProductsProductIdVersionsVersionNoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$'
    | '/'
    | '/accept-invitation'
    | '/login'
    | '/reset-password'
    | '/admin'
    | '/banks'
    | '/collections'
    | '/dashboard'
    | '/documents'
    | '/employers'
    | '/mis'
    | '/my-work'
    | '/operations'
    | '/performance'
    | '/setup'
    | '/staff-commission'
    | '/login/mfa'
    | '/login/mfa-setup'
    | '/account/sessions'
    | '/admin/audit-log'
    | '/admin/external-parties'
    | '/admin/organization'
    | '/admin/teams'
    | '/admin/users'
    | '/banks/new'
    | '/collections/adjustments'
    | '/collections/clawbacks'
    | '/collections/receivables'
    | '/customers/$customerId'
    | '/deals/$dealId'
    | '/deals/new'
    | '/employers/$employerId'
    | '/employers/duplicates'
    | '/employers/enlistments'
    | '/employers/not-in-master'
    | '/mis/movement'
    | '/performance/targets'
    | '/reports/$reportKey'
    | '/staff-commission/adjustments'
    | '/staff-commission/clawbacks'
    | '/staff-commission/rules'
    | '/admin/'
    | '/banks/'
    | '/collections/'
    | '/customers/'
    | '/deals/'
    | '/documents/'
    | '/employers/'
    | '/mis/'
    | '/performance/'
    | '/reports/'
    | '/staff-commission/'
    | '/admin/roles/compare'
    | '/admin/imports/$importId'
    | '/admin/roles/$roleId'
    | '/admin/roles/new'
    | '/banks/$bankId/employer-categories'
    | '/banks/$bankId/stages'
    | '/collections/invoices/$invoiceId'
    | '/collections/invoices/new'
    | '/collections/payments/$paymentId'
    | '/collections/reconciliation/$runId'
    | '/deals/$dealId/activity'
    | '/deals/$dealId/application'
    | '/deals/$dealId/bank-updates'
    | '/deals/$dealId/calculator'
    | '/deals/$dealId/documents'
    | '/deals/$dealId/financial'
    | '/deals/$dealId/operations'
    | '/deals/$dealId/people'
    | '/deals/$dealId/settlement'
    | '/deals/$dealId/edit'
    | '/staff-commission/payout-runs/$runId'
    | '/admin/imports/'
    | '/admin/roles/'
    | '/banks/$bankId/'
    | '/collections/invoices/'
    | '/collections/payments/'
    | '/collections/reconciliation/'
    | '/deals/$dealId/'
    | '/staff-commission/payout-runs/'
    | '/staff-commission/statements/'
    | '/banks/$bankId/products/new'
    | '/staff-commission/statements/$userId/$period'
    | '/deals/$dealId/application/print'
    | '/banks/$bankId/products/$productId/'
    | '/banks/$bankId/products/$productId/versions/$versionNo'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$'
    | '/'
    | '/accept-invitation'
    | '/login'
    | '/reset-password'
    | '/dashboard'
    | '/my-work'
    | '/operations'
    | '/setup'
    | '/login/mfa'
    | '/login/mfa-setup'
    | '/account/sessions'
    | '/admin/audit-log'
    | '/admin/external-parties'
    | '/admin/organization'
    | '/admin/teams'
    | '/admin/users'
    | '/banks/new'
    | '/collections/adjustments'
    | '/collections/clawbacks'
    | '/collections/receivables'
    | '/customers/$customerId'
    | '/deals/new'
    | '/employers/$employerId'
    | '/employers/duplicates'
    | '/employers/enlistments'
    | '/employers/not-in-master'
    | '/mis/movement'
    | '/performance/targets'
    | '/reports/$reportKey'
    | '/staff-commission/adjustments'
    | '/staff-commission/clawbacks'
    | '/staff-commission/rules'
    | '/admin'
    | '/banks'
    | '/collections'
    | '/customers'
    | '/deals'
    | '/documents'
    | '/employers'
    | '/mis'
    | '/performance'
    | '/reports'
    | '/staff-commission'
    | '/admin/roles/compare'
    | '/admin/imports/$importId'
    | '/admin/roles/$roleId'
    | '/admin/roles/new'
    | '/banks/$bankId/employer-categories'
    | '/banks/$bankId/stages'
    | '/collections/invoices/$invoiceId'
    | '/collections/invoices/new'
    | '/collections/payments/$paymentId'
    | '/collections/reconciliation/$runId'
    | '/deals/$dealId/activity'
    | '/deals/$dealId/application'
    | '/deals/$dealId/bank-updates'
    | '/deals/$dealId/calculator'
    | '/deals/$dealId/documents'
    | '/deals/$dealId/financial'
    | '/deals/$dealId/operations'
    | '/deals/$dealId/people'
    | '/deals/$dealId/settlement'
    | '/deals/$dealId/edit'
    | '/staff-commission/payout-runs/$runId'
    | '/admin/imports'
    | '/admin/roles'
    | '/banks/$bankId'
    | '/collections/invoices'
    | '/collections/payments'
    | '/collections/reconciliation'
    | '/deals/$dealId'
    | '/staff-commission/payout-runs'
    | '/staff-commission/statements'
    | '/banks/$bankId/products/new'
    | '/staff-commission/statements/$userId/$period'
    | '/deals/$dealId/application/print'
    | '/banks/$bankId/products/$productId'
    | '/banks/$bankId/products/$productId/versions/$versionNo'
  id:
    | '__root__'
    | '/$'
    | '/_app'
    | '/_print'
    | '/accept-invitation'
    | '/login'
    | '/reset-password'
    | '/_app/admin'
    | '/_app/banks'
    | '/_app/collections'
    | '/_app/dashboard'
    | '/_app/documents'
    | '/_app/employers'
    | '/_app/mis'
    | '/_app/my-work'
    | '/_app/operations'
    | '/_app/performance'
    | '/_app/setup'
    | '/_app/staff-commission'
    | '/login_/mfa'
    | '/login_/mfa-setup'
    | '/_app/'
    | '/_app/account/sessions'
    | '/_app/admin/audit-log'
    | '/_app/admin/external-parties'
    | '/_app/admin/organization'
    | '/_app/admin/teams'
    | '/_app/admin/users'
    | '/_app/banks/new'
    | '/_app/collections/adjustments'
    | '/_app/collections/clawbacks'
    | '/_app/collections/receivables'
    | '/_app/customers/$customerId'
    | '/_app/deals/$dealId'
    | '/_app/deals/new'
    | '/_app/employers/$employerId'
    | '/_app/employers/duplicates'
    | '/_app/employers/enlistments'
    | '/_app/employers/not-in-master'
    | '/_app/mis/movement'
    | '/_app/performance/targets'
    | '/_app/reports/$reportKey'
    | '/_app/staff-commission/adjustments'
    | '/_app/staff-commission/clawbacks'
    | '/_app/staff-commission/rules'
    | '/_app/admin/'
    | '/_app/banks/'
    | '/_app/collections/'
    | '/_app/customers/'
    | '/_app/deals/'
    | '/_app/documents/'
    | '/_app/employers/'
    | '/_app/mis/'
    | '/_app/performance/'
    | '/_app/reports/'
    | '/_app/staff-commission/'
    | '/_app/admin/roles/compare'
    | '/_app/admin_/imports/$importId'
    | '/_app/admin_/roles/$roleId'
    | '/_app/admin_/roles/new'
    | '/_app/banks/$bankId/employer-categories'
    | '/_app/banks/$bankId/stages'
    | '/_app/collections/invoices/$invoiceId'
    | '/_app/collections/invoices/new'
    | '/_app/collections/payments/$paymentId'
    | '/_app/collections/reconciliation/$runId'
    | '/_app/deals/$dealId/activity'
    | '/_app/deals/$dealId/application'
    | '/_app/deals/$dealId/bank-updates'
    | '/_app/deals/$dealId/calculator'
    | '/_app/deals/$dealId/documents'
    | '/_app/deals/$dealId/financial'
    | '/_app/deals/$dealId/operations'
    | '/_app/deals/$dealId/people'
    | '/_app/deals/$dealId/settlement'
    | '/_app/deals/$dealId_/edit'
    | '/_app/staff-commission/payout-runs/$runId'
    | '/_app/admin/imports/'
    | '/_app/admin/roles/'
    | '/_app/banks/$bankId/'
    | '/_app/collections/invoices/'
    | '/_app/collections/payments/'
    | '/_app/collections/reconciliation/'
    | '/_app/deals/$dealId/'
    | '/_app/staff-commission/payout-runs/'
    | '/_app/staff-commission/statements/'
    | '/_app/banks/$bankId/products/new'
    | '/_app/staff-commission/statements/$userId/$period'
    | '/_print/deals/$dealId/application/print'
    | '/_app/banks/$bankId/products/$productId/'
    | '/_app/banks/$bankId/products/$productId/versions/$versionNo'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  SplatRoute: typeof SplatRoute
  AppRoute: typeof AppRouteWithChildren
  PrintRoute: typeof PrintRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  LoginMfaRoute: typeof LoginMfaRoute
  LoginMfaSetupRoute: typeof LoginMfaSetupRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_print': {
      id: '/_print'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PrintRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/banks': {
      id: '/_app/banks'
      path: '/banks'
      fullPath: '/banks'
      preLoaderRoute: typeof AppBanksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/collections': {
      id: '/_app/collections'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof AppCollectionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents': {
      id: '/_app/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AppDocumentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/employers': {
      id: '/_app/employers'
      path: '/employers'
      fullPath: '/employers'
      preLoaderRoute: typeof AppEmployersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mis': {
      id: '/_app/mis'
      path: '/mis'
      fullPath: '/mis'
      preLoaderRoute: typeof AppMisRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-work': {
      id: '/_app/my-work'
      path: '/my-work'
      fullPath: '/my-work'
      preLoaderRoute: typeof AppMyWorkRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/operations': {
      id: '/_app/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof AppOperationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance': {
      id: '/_app/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AppPerformanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/setup': {
      id: '/_app/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof AppSetupRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff-commission': {
      id: '/_app/staff-commission'
      path: '/staff-commission'
      fullPath: '/staff-commission'
      preLoaderRoute: typeof AppStaffCommissionRouteImport
      parentRoute: typeof AppRoute
    }
    '/login_/mfa': {
      id: '/login_/mfa'
      path: '/login/mfa'
      fullPath: '/login/mfa'
      preLoaderRoute: typeof LoginMfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/mfa-setup': {
      id: '/login_/mfa-setup'
      path: '/login/mfa-setup'
      fullPath: '/login/mfa-setup'
      preLoaderRoute: typeof LoginMfaSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account/sessions': {
      id: '/_app/account/sessions'
      path: '/account/sessions'
      fullPath: '/account/sessions'
      preLoaderRoute: typeof AppAccountSessionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit-log': {
      id: '/_app/admin/audit-log'
      path: '/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AppAdminAuditLogRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/external-parties': {
      id: '/_app/admin/external-parties'
      path: '/external-parties'
      fullPath: '/admin/external-parties'
      preLoaderRoute: typeof AppAdminExternalPartiesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/organization': {
      id: '/_app/admin/organization'
      path: '/organization'
      fullPath: '/admin/organization'
      preLoaderRoute: typeof AppAdminOrganizationRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/teams': {
      id: '/_app/admin/teams'
      path: '/teams'
      fullPath: '/admin/teams'
      preLoaderRoute: typeof AppAdminTeamsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/banks/': {
      id: '/_app/banks/'
      path: '/'
      fullPath: '/banks/'
      preLoaderRoute: typeof AppBanksIndexRouteImport
      parentRoute: typeof AppBanksRoute
    }
    '/_app/banks/new': {
      id: '/_app/banks/new'
      path: '/new'
      fullPath: '/banks/new'
      preLoaderRoute: typeof AppBanksNewRouteImport
      parentRoute: typeof AppBanksRoute
    }
    '/_app/collections/': {
      id: '/_app/collections/'
      path: '/'
      fullPath: '/collections/'
      preLoaderRoute: typeof AppCollectionsIndexRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/adjustments': {
      id: '/_app/collections/adjustments'
      path: '/adjustments'
      fullPath: '/collections/adjustments'
      preLoaderRoute: typeof AppCollectionsAdjustmentsRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/clawbacks': {
      id: '/_app/collections/clawbacks'
      path: '/clawbacks'
      fullPath: '/collections/clawbacks'
      preLoaderRoute: typeof AppCollectionsClawbacksRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/receivables': {
      id: '/_app/collections/receivables'
      path: '/receivables'
      fullPath: '/collections/receivables'
      preLoaderRoute: typeof AppCollectionsReceivablesRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/customers/': {
      id: '/_app/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/': {
      id: '/_app/deals/'
      path: '/deals'
      fullPath: '/deals/'
      preLoaderRoute: typeof AppDealsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/$dealId': {
      id: '/_app/deals/$dealId'
      path: '/deals/$dealId'
      fullPath: '/deals/$dealId'
      preLoaderRoute: typeof AppDealsDealIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/deals/new': {
      id: '/_app/deals/new'
      path: '/deals/new'
      fullPath: '/deals/new'
      preLoaderRoute: typeof AppDealsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/documents/': {
      id: '/_app/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppDocumentsRoute
    }
    '/_app/employers/': {
      id: '/_app/employers/'
      path: '/'
      fullPath: '/employers/'
      preLoaderRoute: typeof AppEmployersIndexRouteImport
      parentRoute: typeof AppEmployersRoute
    }
    '/_app/employers/$employerId': {
      id: '/_app/employers/$employerId'
      path: '/$employerId'
      fullPath: '/employers/$employerId'
      preLoaderRoute: typeof AppEmployersEmployerIdRouteImport
      parentRoute: typeof AppEmployersRoute
    }
    '/_app/employers/duplicates': {
      id: '/_app/employers/duplicates'
      path: '/duplicates'
      fullPath: '/employers/duplicates'
      preLoaderRoute: typeof AppEmployersDuplicatesRouteImport
      parentRoute: typeof AppEmployersRoute
    }
    '/_app/employers/enlistments': {
      id: '/_app/employers/enlistments'
      path: '/enlistments'
      fullPath: '/employers/enlistments'
      preLoaderRoute: typeof AppEmployersEnlistmentsRouteImport
      parentRoute: typeof AppEmployersRoute
    }
    '/_app/employers/not-in-master': {
      id: '/_app/employers/not-in-master'
      path: '/not-in-master'
      fullPath: '/employers/not-in-master'
      preLoaderRoute: typeof AppEmployersNotInMasterRouteImport
      parentRoute: typeof AppEmployersRoute
    }
    '/_app/mis/': {
      id: '/_app/mis/'
      path: '/'
      fullPath: '/mis/'
      preLoaderRoute: typeof AppMisIndexRouteImport
      parentRoute: typeof AppMisRoute
    }
    '/_app/mis/movement': {
      id: '/_app/mis/movement'
      path: '/movement'
      fullPath: '/mis/movement'
      preLoaderRoute: typeof AppMisMovementRouteImport
      parentRoute: typeof AppMisRoute
    }
    '/_app/performance/': {
      id: '/_app/performance/'
      path: '/'
      fullPath: '/performance/'
      preLoaderRoute: typeof AppPerformanceIndexRouteImport
      parentRoute: typeof AppPerformanceRoute
    }
    '/_app/performance/targets': {
      id: '/_app/performance/targets'
      path: '/targets'
      fullPath: '/performance/targets'
      preLoaderRoute: typeof AppPerformanceTargetsRouteImport
      parentRoute: typeof AppPerformanceRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/$reportKey': {
      id: '/_app/reports/$reportKey'
      path: '/reports/$reportKey'
      fullPath: '/reports/$reportKey'
      preLoaderRoute: typeof AppReportsReportKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff-commission/': {
      id: '/_app/staff-commission/'
      path: '/'
      fullPath: '/staff-commission/'
      preLoaderRoute: typeof AppStaffCommissionIndexRouteImport
      parentRoute: typeof AppStaffCommissionRoute
    }
    '/_app/staff-commission/adjustments': {
      id: '/_app/staff-commission/adjustments'
      path: '/adjustments'
      fullPath: '/staff-commission/adjustments'
      preLoaderRoute: typeof AppStaffCommissionAdjustmentsRouteImport
      parentRoute: typeof AppStaffCommissionRoute
    }
    '/_app/staff-commission/clawbacks': {
      id: '/_app/staff-commission/clawbacks'
      path: '/clawbacks'
      fullPath: '/staff-commission/clawbacks'
      preLoaderRoute: typeof AppStaffCommissionClawbacksRouteImport
      parentRoute: typeof AppStaffCommissionRoute
    }
    '/_app/staff-commission/rules': {
      id: '/_app/staff-commission/rules'
      path: '/rules'
      fullPath: '/staff-commission/rules'
      preLoaderRoute: typeof AppStaffCommissionRulesRouteImport
      parentRoute: typeof AppStaffCommissionRoute
    }
    '/_app/admin/imports/': {
      id: '/_app/admin/imports/'
      path: '/imports'
      fullPath: '/admin/imports/'
      preLoaderRoute: typeof AppAdminImportsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/roles/': {
      id: '/_app/admin/roles/'
      path: '/roles'
      fullPath: '/admin/roles/'
      preLoaderRoute: typeof AppAdminRolesIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/roles/compare': {
      id: '/_app/admin/roles/compare'
      path: '/roles/compare'
      fullPath: '/admin/roles/compare'
      preLoaderRoute: typeof AppAdminRolesCompareRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin_/imports/$importId': {
      id: '/_app/admin_/imports/$importId'
      path: '/admin/imports/$importId'
      fullPath: '/admin/imports/$importId'
      preLoaderRoute: typeof AppAdminImportsImportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin_/roles/$roleId': {
      id: '/_app/admin_/roles/$roleId'
      path: '/admin/roles/$roleId'
      fullPath: '/admin/roles/$roleId'
      preLoaderRoute: typeof AppAdminRolesRoleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin_/roles/new': {
      id: '/_app/admin_/roles/new'
      path: '/admin/roles/new'
      fullPath: '/admin/roles/new'
      preLoaderRoute: typeof AppAdminRolesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/banks/$bankId/': {
      id: '/_app/banks/$bankId/'
      path: '/$bankId'
      fullPath: '/banks/$bankId/'
      preLoaderRoute: typeof AppBanksBankIdIndexRouteImport
      parentRoute: typeof AppBanksRoute
    }
    '/_app/banks/$bankId/employer-categories': {
      id: '/_app/banks/$bankId/employer-categories'
      path: '/$bankId/employer-categories'
      fullPath: '/banks/$bankId/employer-categories'
      preLoaderRoute: typeof AppBanksBankIdEmployerCategoriesRouteImport
      parentRoute: typeof AppBanksRoute
    }
    '/_app/banks/$bankId/stages': {
      id: '/_app/banks/$bankId/stages'
      path: '/$bankId/stages'
      fullPath: '/banks/$bankId/stages'
      preLoaderRoute: typeof AppBanksBankIdStagesRouteImport
      parentRoute: typeof AppBanksRoute
    }
    '/_app/collections/invoices/': {
      id: '/_app/collections/invoices/'
      path: '/invoices'
      fullPath: '/collections/invoices/'
      preLoaderRoute: typeof AppCollectionsInvoicesIndexRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/invoices/$invoiceId': {
      id: '/_app/collections/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/collections/invoices/$invoiceId'
      preLoaderRoute: typeof AppCollectionsInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/invoices/new': {
      id: '/_app/collections/invoices/new'
      path: '/invoices/new'
      fullPath: '/collections/invoices/new'
      preLoaderRoute: typeof AppCollectionsInvoicesNewRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/payments/': {
      id: '/_app/collections/payments/'
      path: '/payments'
      fullPath: '/collections/payments/'
      preLoaderRoute: typeof AppCollectionsPaymentsIndexRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/payments/$paymentId': {
      id: '/_app/collections/payments/$paymentId'
      path: '/payments/$paymentId'
      fullPath: '/collections/payments/$paymentId'
      preLoaderRoute: typeof AppCollectionsPaymentsPaymentIdRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/reconciliation/': {
      id: '/_app/collections/reconciliation/'
      path: '/reconciliation'
      fullPath: '/collections/reconciliation/'
      preLoaderRoute: typeof AppCollectionsReconciliationIndexRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/collections/reconciliation/$runId': {
      id: '/_app/collections/reconciliation/$runId'
      path: '/reconciliation/$runId'
      fullPath: '/collections/reconciliation/$runId'
      preLoaderRoute: typeof AppCollectionsReconciliationRunIdRouteImport
      parentRoute: typeof AppCollectionsRoute
    }
    '/_app/deals/$dealId/': {
      id: '/_app/deals/$dealId/'
      path: '/'
      fullPath: '/deals/$dealId/'
      preLoaderRoute: typeof AppDealsDealIdIndexRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/activity': {
      id: '/_app/deals/$dealId/activity'
      path: '/activity'
      fullPath: '/deals/$dealId/activity'
      preLoaderRoute: typeof AppDealsDealIdActivityRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/application': {
      id: '/_app/deals/$dealId/application'
      path: '/application'
      fullPath: '/deals/$dealId/application'
      preLoaderRoute: typeof AppDealsDealIdApplicationRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/bank-updates': {
      id: '/_app/deals/$dealId/bank-updates'
      path: '/bank-updates'
      fullPath: '/deals/$dealId/bank-updates'
      preLoaderRoute: typeof AppDealsDealIdBankUpdatesRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/calculator': {
      id: '/_app/deals/$dealId/calculator'
      path: '/calculator'
      fullPath: '/deals/$dealId/calculator'
      preLoaderRoute: typeof AppDealsDealIdCalculatorRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/documents': {
      id: '/_app/deals/$dealId/documents'
      path: '/documents'
      fullPath: '/deals/$dealId/documents'
      preLoaderRoute: typeof AppDealsDealIdDocumentsRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/financial': {
      id: '/_app/deals/$dealId/financial'
      path: '/financial'
      fullPath: '/deals/$dealId/financial'
      preLoaderRoute: typeof AppDealsDealIdFinancialRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/operations': {
      id: '/_app/deals/$dealId/operations'
      path: '/operations'
      fullPath: '/deals/$dealId/operations'
      preLoaderRoute: typeof AppDealsDealIdOperationsRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/people': {
      id: '/_app/deals/$dealId/people'
      path: '/people'
      fullPath: '/deals/$dealId/people'
      preLoaderRoute: typeof AppDealsDealIdPeopleRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId/settlement': {
      id: '/_app/deals/$dealId/settlement'
      path: '/settlement'
      fullPath: '/deals/$dealId/settlement'
      preLoaderRoute: typeof AppDealsDealIdSettlementRouteImport
      parentRoute: typeof AppDealsDealIdRoute
    }
    '/_app/deals/$dealId_/edit': {
      id: '/_app/deals/$dealId_/edit'
      path: '/deals/$dealId/edit'
      fullPath: '/deals/$dealId/edit'
      preLoaderRoute: typeof AppDealsDealIdEditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff-commission/payout-runs/': {
      id: '/_app/staff-commission/payout-runs/'
      path: '/payout-runs'
      fullPath: '/staff-commission/payout-runs/'
      preLoaderRoute: typeof AppStaffCommissionPayoutRunsIndexRouteImport
      parentRoute: typeof AppStaffCommissionRoute
    }
    '/_app/staff-commission/payout-runs/$runId': {
      id: '/_app/staff-commission/payout-runs/$runId'
      path: '/payout-runs/$runId'
      fullPath: '/staff-commission/payout-runs/$runId'
      preLoaderRoute: typeof AppStaffCommissionPayoutRunsRunIdRouteImport
      parentRoute: typeof AppStaffCommissionRoute
    }
    '/_app/staff-commission/statements/': {
      id: '/_app/staff-commission/statements/'
      path: '/statements'
      fullPath: '/staff-commission/statements/'
      preLoaderRoute: typeof AppStaffCommissionStatementsIndexRouteImport
      parentRoute: typeof AppStaffCommissionRoute
    }
    '/_app/banks/$bankId/products/new': {
      id: '/_app/banks/$bankId/products/new'
      path: '/$bankId/products/new'
      fullPath: '/banks/$bankId/products/new'
      preLoaderRoute: typeof AppBanksBankIdProductsNewRouteImport
      parentRoute: typeof AppBanksRoute
    }
    '/_app/staff-commission/statements/$userId/$period': {
      id: '/_app/staff-commission/statements/$userId/$period'
      path: '/statements/$userId/$period'
      fullPath: '/staff-commission/statements/$userId/$period'
      preLoaderRoute: typeof AppStaffCommissionStatementsUserIdPeriodRouteImport
      parentRoute: typeof AppStaffCommissionRoute
    }
    '/_print/deals/$dealId/application/print': {
      id: '/_print/deals/$dealId/application/print'
      path: '/deals/$dealId/application/print'
      fullPath: '/deals/$dealId/application/print'
      preLoaderRoute: typeof PrintDealsDealIdApplicationPrintRouteImport
      parentRoute: typeof PrintRoute
    }
    '/_app/banks/$bankId/products/$productId/': {
      id: '/_app/banks/$bankId/products/$productId/'
      path: '/$bankId/products/$productId'
      fullPath: '/banks/$bankId/products/$productId/'
      preLoaderRoute: typeof AppBanksBankIdProductsProductIdIndexRouteImport
      parentRoute: typeof AppBanksRoute
    }
    '/_app/banks/$bankId/products/$productId/versions/$versionNo': {
      id: '/_app/banks/$bankId/products/$productId/versions/$versionNo'
      path: '/$bankId/products/$productId/versions/$versionNo'
      fullPath: '/banks/$bankId/products/$productId/versions/$versionNo'
      preLoaderRoute: typeof AppBanksBankIdProductsProductIdVersionsVersionNoRouteImport
      parentRoute: typeof AppBanksRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAuditLogRoute: typeof AppAdminAuditLogRoute
  AppAdminExternalPartiesRoute: typeof AppAdminExternalPartiesRoute
  AppAdminOrganizationRoute: typeof AppAdminOrganizationRoute
  AppAdminTeamsRoute: typeof AppAdminTeamsRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminRolesCompareRoute: typeof AppAdminRolesCompareRoute
  AppAdminImportsIndexRoute: typeof AppAdminImportsIndexRoute
  AppAdminRolesIndexRoute: typeof AppAdminRolesIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAuditLogRoute: AppAdminAuditLogRoute,
  AppAdminExternalPartiesRoute: AppAdminExternalPartiesRoute,
  AppAdminOrganizationRoute: AppAdminOrganizationRoute,
  AppAdminTeamsRoute: AppAdminTeamsRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminRolesCompareRoute: AppAdminRolesCompareRoute,
  AppAdminImportsIndexRoute: AppAdminImportsIndexRoute,
  AppAdminRolesIndexRoute: AppAdminRolesIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppBanksRouteChildren {
  AppBanksNewRoute: typeof AppBanksNewRoute
  AppBanksIndexRoute: typeof AppBanksIndexRoute
  AppBanksBankIdEmployerCategoriesRoute: typeof AppBanksBankIdEmployerCategoriesRoute
  AppBanksBankIdStagesRoute: typeof AppBanksBankIdStagesRoute
  AppBanksBankIdIndexRoute: typeof AppBanksBankIdIndexRoute
  AppBanksBankIdProductsNewRoute: typeof AppBanksBankIdProductsNewRoute
  AppBanksBankIdProductsProductIdIndexRoute: typeof AppBanksBankIdProductsProductIdIndexRoute
  AppBanksBankIdProductsProductIdVersionsVersionNoRoute: typeof AppBanksBankIdProductsProductIdVersionsVersionNoRoute
}

const AppBanksRouteChildren: AppBanksRouteChildren = {
  AppBanksNewRoute: AppBanksNewRoute,
  AppBanksIndexRoute: AppBanksIndexRoute,
  AppBanksBankIdEmployerCategoriesRoute: AppBanksBankIdEmployerCategoriesRoute,
  AppBanksBankIdStagesRoute: AppBanksBankIdStagesRoute,
  AppBanksBankIdIndexRoute: AppBanksBankIdIndexRoute,
  AppBanksBankIdProductsNewRoute: AppBanksBankIdProductsNewRoute,
  AppBanksBankIdProductsProductIdIndexRoute:
    AppBanksBankIdProductsProductIdIndexRoute,
  AppBanksBankIdProductsProductIdVersionsVersionNoRoute:
    AppBanksBankIdProductsProductIdVersionsVersionNoRoute,
}

const AppBanksRouteWithChildren = AppBanksRoute._addFileChildren(
  AppBanksRouteChildren,
)

interface AppCollectionsRouteChildren {
  AppCollectionsAdjustmentsRoute: typeof AppCollectionsAdjustmentsRoute
  AppCollectionsClawbacksRoute: typeof AppCollectionsClawbacksRoute
  AppCollectionsReceivablesRoute: typeof AppCollectionsReceivablesRoute
  AppCollectionsIndexRoute: typeof AppCollectionsIndexRoute
  AppCollectionsInvoicesInvoiceIdRoute: typeof AppCollectionsInvoicesInvoiceIdRoute
  AppCollectionsInvoicesNewRoute: typeof AppCollectionsInvoicesNewRoute
  AppCollectionsPaymentsPaymentIdRoute: typeof AppCollectionsPaymentsPaymentIdRoute
  AppCollectionsReconciliationRunIdRoute: typeof AppCollectionsReconciliationRunIdRoute
  AppCollectionsInvoicesIndexRoute: typeof AppCollectionsInvoicesIndexRoute
  AppCollectionsPaymentsIndexRoute: typeof AppCollectionsPaymentsIndexRoute
  AppCollectionsReconciliationIndexRoute: typeof AppCollectionsReconciliationIndexRoute
}

const AppCollectionsRouteChildren: AppCollectionsRouteChildren = {
  AppCollectionsAdjustmentsRoute: AppCollectionsAdjustmentsRoute,
  AppCollectionsClawbacksRoute: AppCollectionsClawbacksRoute,
  AppCollectionsReceivablesRoute: AppCollectionsReceivablesRoute,
  AppCollectionsIndexRoute: AppCollectionsIndexRoute,
  AppCollectionsInvoicesInvoiceIdRoute: AppCollectionsInvoicesInvoiceIdRoute,
  AppCollectionsInvoicesNewRoute: AppCollectionsInvoicesNewRoute,
  AppCollectionsPaymentsPaymentIdRoute: AppCollectionsPaymentsPaymentIdRoute,
  AppCollectionsReconciliationRunIdRoute:
    AppCollectionsReconciliationRunIdRoute,
  AppCollectionsInvoicesIndexRoute: AppCollectionsInvoicesIndexRoute,
  AppCollectionsPaymentsIndexRoute: AppCollectionsPaymentsIndexRoute,
  AppCollectionsReconciliationIndexRoute:
    AppCollectionsReconciliationIndexRoute,
}

const AppCollectionsRouteWithChildren = AppCollectionsRoute._addFileChildren(
  AppCollectionsRouteChildren,
)

interface AppDocumentsRouteChildren {
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
}

const AppDocumentsRouteChildren: AppDocumentsRouteChildren = {
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
}

const AppDocumentsRouteWithChildren = AppDocumentsRoute._addFileChildren(
  AppDocumentsRouteChildren,
)

interface AppEmployersRouteChildren {
  AppEmployersEmployerIdRoute: typeof AppEmployersEmployerIdRoute
  AppEmployersDuplicatesRoute: typeof AppEmployersDuplicatesRoute
  AppEmployersEnlistmentsRoute: typeof AppEmployersEnlistmentsRoute
  AppEmployersNotInMasterRoute: typeof AppEmployersNotInMasterRoute
  AppEmployersIndexRoute: typeof AppEmployersIndexRoute
}

const AppEmployersRouteChildren: AppEmployersRouteChildren = {
  AppEmployersEmployerIdRoute: AppEmployersEmployerIdRoute,
  AppEmployersDuplicatesRoute: AppEmployersDuplicatesRoute,
  AppEmployersEnlistmentsRoute: AppEmployersEnlistmentsRoute,
  AppEmployersNotInMasterRoute: AppEmployersNotInMasterRoute,
  AppEmployersIndexRoute: AppEmployersIndexRoute,
}

const AppEmployersRouteWithChildren = AppEmployersRoute._addFileChildren(
  AppEmployersRouteChildren,
)

interface AppMisRouteChildren {
  AppMisMovementRoute: typeof AppMisMovementRoute
  AppMisIndexRoute: typeof AppMisIndexRoute
}

const AppMisRouteChildren: AppMisRouteChildren = {
  AppMisMovementRoute: AppMisMovementRoute,
  AppMisIndexRoute: AppMisIndexRoute,
}

const AppMisRouteWithChildren =
  AppMisRoute._addFileChildren(AppMisRouteChildren)

interface AppPerformanceRouteChildren {
  AppPerformanceTargetsRoute: typeof AppPerformanceTargetsRoute
  AppPerformanceIndexRoute: typeof AppPerformanceIndexRoute
}

const AppPerformanceRouteChildren: AppPerformanceRouteChildren = {
  AppPerformanceTargetsRoute: AppPerformanceTargetsRoute,
  AppPerformanceIndexRoute: AppPerformanceIndexRoute,
}

const AppPerformanceRouteWithChildren = AppPerformanceRoute._addFileChildren(
  AppPerformanceRouteChildren,
)

interface AppStaffCommissionRouteChildren {
  AppStaffCommissionAdjustmentsRoute: typeof AppStaffCommissionAdjustmentsRoute
  AppStaffCommissionClawbacksRoute: typeof AppStaffCommissionClawbacksRoute
  AppStaffCommissionRulesRoute: typeof AppStaffCommissionRulesRoute
  AppStaffCommissionIndexRoute: typeof AppStaffCommissionIndexRoute
  AppStaffCommissionPayoutRunsRunIdRoute: typeof AppStaffCommissionPayoutRunsRunIdRoute
  AppStaffCommissionPayoutRunsIndexRoute: typeof AppStaffCommissionPayoutRunsIndexRoute
  AppStaffCommissionStatementsIndexRoute: typeof AppStaffCommissionStatementsIndexRoute
  AppStaffCommissionStatementsUserIdPeriodRoute: typeof AppStaffCommissionStatementsUserIdPeriodRoute
}

const AppStaffCommissionRouteChildren: AppStaffCommissionRouteChildren = {
  AppStaffCommissionAdjustmentsRoute: AppStaffCommissionAdjustmentsRoute,
  AppStaffCommissionClawbacksRoute: AppStaffCommissionClawbacksRoute,
  AppStaffCommissionRulesRoute: AppStaffCommissionRulesRoute,
  AppStaffCommissionIndexRoute: AppStaffCommissionIndexRoute,
  AppStaffCommissionPayoutRunsRunIdRoute:
    AppStaffCommissionPayoutRunsRunIdRoute,
  AppStaffCommissionPayoutRunsIndexRoute:
    AppStaffCommissionPayoutRunsIndexRoute,
  AppStaffCommissionStatementsIndexRoute:
    AppStaffCommissionStatementsIndexRoute,
  AppStaffCommissionStatementsUserIdPeriodRoute:
    AppStaffCommissionStatementsUserIdPeriodRoute,
}

const AppStaffCommissionRouteWithChildren =
  AppStaffCommissionRoute._addFileChildren(AppStaffCommissionRouteChildren)

interface AppDealsDealIdRouteChildren {
  AppDealsDealIdActivityRoute: typeof AppDealsDealIdActivityRoute
  AppDealsDealIdApplicationRoute: typeof AppDealsDealIdApplicationRoute
  AppDealsDealIdBankUpdatesRoute: typeof AppDealsDealIdBankUpdatesRoute
  AppDealsDealIdCalculatorRoute: typeof AppDealsDealIdCalculatorRoute
  AppDealsDealIdDocumentsRoute: typeof AppDealsDealIdDocumentsRoute
  AppDealsDealIdFinancialRoute: typeof AppDealsDealIdFinancialRoute
  AppDealsDealIdOperationsRoute: typeof AppDealsDealIdOperationsRoute
  AppDealsDealIdPeopleRoute: typeof AppDealsDealIdPeopleRoute
  AppDealsDealIdSettlementRoute: typeof AppDealsDealIdSettlementRoute
  AppDealsDealIdIndexRoute: typeof AppDealsDealIdIndexRoute
}

const AppDealsDealIdRouteChildren: AppDealsDealIdRouteChildren = {
  AppDealsDealIdActivityRoute: AppDealsDealIdActivityRoute,
  AppDealsDealIdApplicationRoute: AppDealsDealIdApplicationRoute,
  AppDealsDealIdBankUpdatesRoute: AppDealsDealIdBankUpdatesRoute,
  AppDealsDealIdCalculatorRoute: AppDealsDealIdCalculatorRoute,
  AppDealsDealIdDocumentsRoute: AppDealsDealIdDocumentsRoute,
  AppDealsDealIdFinancialRoute: AppDealsDealIdFinancialRoute,
  AppDealsDealIdOperationsRoute: AppDealsDealIdOperationsRoute,
  AppDealsDealIdPeopleRoute: AppDealsDealIdPeopleRoute,
  AppDealsDealIdSettlementRoute: AppDealsDealIdSettlementRoute,
  AppDealsDealIdIndexRoute: AppDealsDealIdIndexRoute,
}

const AppDealsDealIdRouteWithChildren = AppDealsDealIdRoute._addFileChildren(
  AppDealsDealIdRouteChildren,
)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppBanksRoute: typeof AppBanksRouteWithChildren
  AppCollectionsRoute: typeof AppCollectionsRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppDocumentsRoute: typeof AppDocumentsRouteWithChildren
  AppEmployersRoute: typeof AppEmployersRouteWithChildren
  AppMisRoute: typeof AppMisRouteWithChildren
  AppMyWorkRoute: typeof AppMyWorkRoute
  AppOperationsRoute: typeof AppOperationsRoute
  AppPerformanceRoute: typeof AppPerformanceRouteWithChildren
  AppSetupRoute: typeof AppSetupRoute
  AppStaffCommissionRoute: typeof AppStaffCommissionRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppAccountSessionsRoute: typeof AppAccountSessionsRoute
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppDealsDealIdRoute: typeof AppDealsDealIdRouteWithChildren
  AppDealsNewRoute: typeof AppDealsNewRoute
  AppReportsReportKeyRoute: typeof AppReportsReportKeyRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppDealsIndexRoute: typeof AppDealsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppAdminImportsImportIdRoute: typeof AppAdminImportsImportIdRoute
  AppAdminRolesRoleIdRoute: typeof AppAdminRolesRoleIdRoute
  AppAdminRolesNewRoute: typeof AppAdminRolesNewRoute
  AppDealsDealIdEditRoute: typeof AppDealsDealIdEditRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppBanksRoute: AppBanksRouteWithChildren,
  AppCollectionsRoute: AppCollectionsRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppDocumentsRoute: AppDocumentsRouteWithChildren,
  AppEmployersRoute: AppEmployersRouteWithChildren,
  AppMisRoute: AppMisRouteWithChildren,
  AppMyWorkRoute: AppMyWorkRoute,
  AppOperationsRoute: AppOperationsRoute,
  AppPerformanceRoute: AppPerformanceRouteWithChildren,
  AppSetupRoute: AppSetupRoute,
  AppStaffCommissionRoute: AppStaffCommissionRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppAccountSessionsRoute: AppAccountSessionsRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppDealsDealIdRoute: AppDealsDealIdRouteWithChildren,
  AppDealsNewRoute: AppDealsNewRoute,
  AppReportsReportKeyRoute: AppReportsReportKeyRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppDealsIndexRoute: AppDealsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppAdminImportsImportIdRoute: AppAdminImportsImportIdRoute,
  AppAdminRolesRoleIdRoute: AppAdminRolesRoleIdRoute,
  AppAdminRolesNewRoute: AppAdminRolesNewRoute,
  AppDealsDealIdEditRoute: AppDealsDealIdEditRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PrintRouteChildren {
  PrintDealsDealIdApplicationPrintRoute: typeof PrintDealsDealIdApplicationPrintRoute
}

const PrintRouteChildren: PrintRouteChildren = {
  PrintDealsDealIdApplicationPrintRoute: PrintDealsDealIdApplicationPrintRoute,
}

const PrintRouteWithChildren = PrintRoute._addFileChildren(PrintRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  SplatRoute: SplatRoute,
  AppRoute: AppRouteWithChildren,
  PrintRoute: PrintRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  LoginMfaRoute: LoginMfaRoute,
  LoginMfaSetupRoute: LoginMfaSetupRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
